import React from "react";
import AddAssetServicesDataComponent from "./PropertyAddAssetServicesDataComponent";
import PropertyManagementComponent from "./PropertyManagementComponent";
import PropertyHistoryContainer from "./PropertyHistoryContainer";
import { prop_management_contact_options } from "../deal/constants";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

const HeaderContainer = styled("div")({
    display: "flex",
    width: "100%",
    padding: "16px 0",
});

const HeaderContent = styled("div")({
    flex: "1 1 auto",
});

const PropertyAssetServicesTab = (props) => {
    const {
        role,
        property,
        propertyManagement,
        autocompleteResults,
        searchKMPerson,
        handleInput,
        handleAddArrayElement,
        handleDeleteArrayElement,
        handleUpdateArrayElement,
        handleSearchCompany,
        errors,
        tab,
        addPropertyManagementSection,
        hasPortfolioProperties,
        propertyManagementSnapshots,
        location,
    } = props;

    return (
        <React.Fragment>
            {tab === "property_management" && (
                <React.Fragment>
                    {propertyManagement && propertyManagement.propertyManagementKey ? (
                        <PropertyManagementComponent
                            {...props}
                            role={role}
                            property={property}
                            propertyManagement={propertyManagement}
                            autocompleteResults={autocompleteResults}
                            searchKMPerson={searchKMPerson}
                            handleInput={handleInput}
                            handleAddArrayElement={handleAddArrayElement}
                            handleDeleteArrayElement={handleDeleteArrayElement}
                            handleUpdateArrayElement={handleUpdateArrayElement}
                            prop_management_contact_options={prop_management_contact_options}
                            handleSearchCompany={handleSearchCompany}
                            isSnapshot={false}
                            hasPortfolioProperties={hasPortfolioProperties}
                            propertyManagementSnapshots={propertyManagementSnapshots}
                        />
                    ) : (
                        <AddAssetServicesDataComponent
                            role={role}
                            addPropertyManagementSection={addPropertyManagementSection}
                            property={property}
                        />
                    )}
                    <Divider />
                    <HeaderContainer>
                        <HeaderContent>
                            <h3>Property History</h3>
                        </HeaderContent>
                    </HeaderContainer>
                    <PropertyHistoryContainer
                        role={role}
                        property={property}
                        propertyManagement={propertyManagement}
                        autocompleteResults={autocompleteResults}
                        searchKMPerson={searchKMPerson}
                        handleInput={handleInput}
                        handleAddArrayElement={handleAddArrayElement}
                        handleDeleteArrayElement={handleDeleteArrayElement}
                        handleUpdateArrayElement={handleUpdateArrayElement}
                        prop_management_contact_options={prop_management_contact_options}
                        handleSearchCompany={handleSearchCompany}
                        errors={errors}
                        snapshots={propertyManagementSnapshots}
                        location={location}
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default PropertyAssetServicesTab;